module.exports = __webpack_public_path__ + "assets/img/index_plat_five.9f7c6788.png";